import { fetchEntries, fetchOneEntry } from '@builder.io/sdk-vue';
import { customClientErrorHandler } from "~/services-optimized/customErrorService";
import { EcomService } from "~/services/ecom.service";
import {generateKeyFromObject} from "~/utils/string";

export const getBuilderList = async ({
    model = 'pages',
    query = {},
    sort = {},
    locale = 'nl-NL',
    limit = 10,
    offset = 0,
    apiKey = null
},  nuxtApp: any = null, redisCacheBurst = false) => {
    const options = {
        model: model,
        apiKey: apiKey,
        locale: locale,
        query: query,
        sort: sort,
        limit: limit,
        offset: offset
    }

    let key = model+'-'+await generateKeyFromObject(options);
    if(nuxtApp && nuxtApp.$redis && !redisCacheBurst){
        const data = await EcomService.getRedisDataByKey(nuxtApp.$redis,key);

        if(data){
            return JSON.parse(data);
        }
    }

    try {
        const response =  await fetchEntries(options);

        if(nuxtApp && nuxtApp.$redis){
            nuxtApp.$redis.set(key,JSON.stringify(response), "EX", 200);
        }

        return response;
    } catch (error) {
        customClientErrorHandler(
            error,
            'critical',
            'Builder Error - fetchEntries',
            options
        )
        throw error;
    }
};


export const getPageContent = async (
    urlPath = '/404',
    locale = 'nl-NL',
    apiKey: any = null,
    nuxtApp: any = null
) => {

    const options = {
        locale: locale === 'nl-NL'?'Default':locale,
        model: 'page',
        apiKey: apiKey,
        query: {},
        userAttributes: {
            urlPath: urlPath
        },
        options: {
            fields: "data"
        },
    }

    let key = 'page'+'-'+urlPath+'-'+await generateKeyFromObject(options);

    if(nuxtApp && nuxtApp.$redis){
        const data = await EcomService.getRedisDataByKey(nuxtApp.$redis,key);

        if(data){
            return JSON.parse(data);
        }
    }

    try {
        const response = await fetchOneEntry(options);

        if(nuxtApp && nuxtApp.$redis){
            nuxtApp.$redis.set(key,JSON.stringify(response), "EX", 200);
        }

        return response;
    } catch (error) {
        customClientErrorHandler(
            error,
            'critical',
            'Builder Error - fetchOneEntry',
            options
        );
        throw error;
    }
};

export const getPopularKeywords = async (apiKey: any,
                                         nuxtApp: any = null) => {

    const options = {
        model: 'popular-keywords',
        query: {},
        sort: {},
        limit: 10,
        offset: 0,
        apiKey: apiKey,
    }

    let key = JSON.stringify(options);
    if(nuxtApp && nuxtApp.$redis){
        const data = await EcomService.getRedisDataByKey(nuxtApp.$redis,key);

        if(data){
            return JSON.parse(data);
        }
    }

    try {
        const results = await getBuilderList(options);

        if (results?.length < 1) {
            return []
        }

        const response = results?.map(item => ({ keyword: item.data?.keyword || '' }));

        if(nuxtApp && nuxtApp.$redis){
            nuxtApp.$redis.set(key,JSON.stringify(response), "EX", 200);
        }

        return response;

    } catch (error) {
        customClientErrorHandler(
            error,
            'critical',
            'Builder Error - getPopularKeywords',
            options
        );
        throw error;
    }
};


export const getHeaderMenu = async (locale: any, apiKey: any,
                                    nuxtApp: any = null,
                                    redisCacheBurst = false) => {
    const options = {
        model: 'header-links',
        locale: locale,
        apiKey: apiKey,
    }
    try {
        return await getBuilderList(options,nuxtApp,redisCacheBurst);
    } catch (error) {
        let errorMeta = {
            ...options,
            builderError: true
        }
        customClientErrorHandler(
            error,
            'critical',
            'Builder Error - getHeaderMenu',
            errorMeta
        );
        throw error;
    }
};

export const getBlogList = async (apiKey: any, opts: object,
                                  nuxtApp: any = null) => {
    const options = {
        model: 'blogs',
        query: {},
        sort: {},
        limit: 100,
        offset: 0,
        apiKey,
        ...opts
    }

    let key = JSON.stringify(options);
    if(nuxtApp && nuxtApp.$redis){
        const data = await EcomService.getRedisDataByKey(nuxtApp.$redis,key);

        if(data){
            return JSON.parse(data);
        }
    }

    try {
        const response =  await fetchEntries(options);

        if(nuxtApp && nuxtApp.$redis){
            nuxtApp.$redis.set(key,JSON.stringify(response), "EX", 200);
        }

        return response;
    } catch (error) {
        customClientErrorHandler(
            error,
            'critical',
            'Builder Error - getBlogList',
            options
        );
        throw error;
    }
};

export const getFooterLinks = async (apiKey: any, opts: object,
                                     nuxtApp: any = null,redisCacheBurst = false) => {
    const options = {
        model: 'footer-links',
        apiKey: apiKey,
        ...opts
    }
    try {
        return await getBuilderList(options,nuxtApp,redisCacheBurst);
    } catch (error) {
        let errorMeta = {
            ...options,
            builderError: true
        }
        customClientErrorHandler(
            error,
            'critical',
            'Builder Error - getFooterLinks',
            errorMeta
        );
        throw error;
    }
};

export const getProCardPopUpConsentData = async (apiKey: any, opts: object,
                                                 nuxtApp: any = null) => {
    const options = {
        model: 'pro-card-terms-and-condition',
        apiKey: apiKey,
        ...opts
    }

    let key = JSON.stringify(options);
    if(nuxtApp && nuxtApp.$redis){
        const data = await EcomService.getRedisDataByKey(nuxtApp.$redis,key);

        if(data){
            return JSON.parse(data);
        }
    }

    try {
        const response = await getBuilderList(options);

        if(nuxtApp && nuxtApp.$redis){
            nuxtApp.$redis.set(key,JSON.stringify(response), "EX", 200);
        }

        return response;
    } catch (error) {
        let errorMeta = {
            ...options,
            builderError: true
        }
        customClientErrorHandler(
            error,
            'critical',
            'Builder Error - getProCardPopUpConsentData',
            errorMeta
        );
        throw error;
    }
};